import * as queries from "../../graphql/queries";
import * as mutations from "../../graphql/mutations";
import {
  CreateProgramInput,
  CreateProgramMembershipInput,
  CreateProgramMembershipMutation,
  CreateProgramMutation,
  DeleteProgramInput,
  DeleteProgramMutation,
  GetProgramQuery,
  ListProgramsQuery,
  ModelProgramConnection,
  Program,
  ProgramMembership,
  UpdateProgramInput,
  UpdateProgramMutation,
  ListSponsorsQuery,
  ModelSponsorConnection,
  Sponsor,
  ProgramsByInstitutionQuery
} from "../../API";
import { API } from "aws-amplify";
import { genericQuery, fetchAllWithPagination, listQueryAutoPaginated } from "../api/apiUtils";

export const fetchProgram = async (id: string) =>
  (await API.get("simpl-api", `program/${id}`, {})) as Program;

export const deleteProgram = async (input: DeleteProgramInput) => {
  const predicate = { input: input };
  return await genericQuery<DeleteProgramMutation, Program>(
    mutations.deleteProgram,
    "deleteProgram",
    predicate
  );
};

export const fetchAllPrograms = async (): Promise<Program[] | null> => {
  return await fetchAllWithPagination<Program>("programs", "programs", 500);
};

export const createProgram = async (input: CreateProgramInput) => {
  const path = `program`;
  return (await API.put("simpl-api", path, {
    body: input
  })) as Program;
};

export const updateProgram = async (input: UpdateProgramInput) => {
  const { id, ...updates } = input;

  return (await API.put("simpl-api", `program/${id}`, {
    body: updates
  })) as Program;
};

export const createProgramMembership = async (
  input: CreateProgramMembershipInput
) => {
  const predicate = { input: input };
  return await genericQuery<CreateProgramMembershipMutation, ProgramMembership>(
    mutations.createProgramMembership,
    "createProgramMembership",
    predicate
  );
};

export const fetchProgramsByIntitutionId = async (institutionId: string) => {
  const predicate = { institutionId: institutionId };
  return await listQueryAutoPaginated<
    ProgramsByInstitutionQuery,
    Program,
    ModelProgramConnection
  >(queries.programsByInstitution, "programsByInstitution", "items", predicate);
};
